import { useAppSelector } from 'hooks/redux';
import { RootState } from 'store/configureStore';

export function getSpotById(id: string): any {
  const spotList = useAppSelector((state: RootState) => state.spot.list);
  if (Array.isArray(spotList)) return spotList.find((s) => s.id == id);
}
